import { Block, ProgressBar } from "@business-finland/wif-ui-lib";

import { getCompanyFormClsx, getCompanyFormId } from "../helpers";
import { useCompanyFormState } from "../store";

export default function CompanyFormProgressBar() {
  const { currentStep, totalSteps } = useCompanyFormState();
  return (
    <Block
      id={getCompanyFormId("progress")}
      topPadding={Block.Padding.NONE}
      bottomPadding={Block.Padding.SMALL}
    >
      <Block.Content>
        <div className={getCompanyFormClsx("main")}>
          <ProgressBar
            totalSteps={totalSteps}
            currentStep={currentStep}
            ofLabel={undefined}
            stepLabel={undefined}
          />
        </div>
      </Block.Content>
    </Block>
  );
}
